import { Component, Vue } from 'vue-property-decorator';
import SettingService from '@/modules/services/setting.service';
import Config from '../../services/DatatableConfig';
import VueBootstrap4Table from 'vue-bootstrap4-table';
import Commonservice from '../../services/common.service';
import DatePicker from "@/modules/shared/components/DatePickerControl.vue";

const commonservice = new Commonservice();

const settingService = new SettingService();
const config = new Config();
@Component({
  components: {
    VueBootstrap4Table,
    DatePicker,
  },
})
export default class UserActivity extends Vue {
  public UserActivityData: [] = [];
  private TableHeaders: any = [];
  private TableConfig: any;
   // New variables created for pagination
   public page_number = 1;
   public start_count = 0;
   public end_count = 0;
   public data_count = 0;
   public UserForm = {
     start_date: '',
     end_date:''
   }

  public created() {
    // config.tableconfig.server_mode = true;
    $(document).prop('title', 'Dshop User Activity')
    this.createUserAcrivityTable();
    this.getUserActivity();
    this.filterpaginate("fresh")
  }
  private filterpaginate(flag: any) {
    // this.$store.state.Loading = true;
    if (flag == "pageClick") {
      $('.pagination input[type=number]').val("");
    }
    if (flag == "fresh") {
      this.page_number = 1;
      var page_count = 10
    } else {
      this.page_number = parseInt($('.page-item.active .page-link').text());
      var page_count = parseInt($('.vbt-per-page-dropdown #dropdownMenuLink').text())
    }
    this.start_count = 0;
    this.end_count = 0;
    if (!this.page_number) {
      this.page_number = 1;
    }
    if (!page_count) {
      page_count = 10;
    }
    this.start_count = ((+page_count * (+this.page_number - 1)) + 1);
    this.end_count = ((+page_count * (+this.page_number - 1)) + +page_count);
    console.log("data count - " + this.data_count + " || End count " + this.end_count);
    if (flag != "fresh" && this.end_count > this.data_count) {
      this.end_count = this.data_count;
    } else if (flag == "fresh") {
      setTimeout(() => {
        if (this.end_count > this.data_count) {
          this.end_count = this.data_count;
        }
      }, 1000)
    }
    // this.$store.state.Loading = false;
  }
  private mounted() {
    //script for double scroll
    setTimeout(() => {
      $('.card-body').prepend('<div class="table-topscroll"><div class="scroll-div1"></div></div>');
      $('.table-topscroll .scroll-div1').width(document.querySelector('.card-body .table-responsive').scrollWidth + 1);
      $('.table-topscroll').scroll(function () {
        $('.table-responsive')
          .scrollLeft($('.table-topscroll').scrollLeft());
      });
      $('.table-responsive').scroll(function () {
        $('.table-topscroll')
          .scrollLeft($('.table-responsive').scrollLeft());
      });

      var ulDiv = document.getElementsByClassName("pagination")[0]
      ulDiv.addEventListener('click', (event) => {
        this.filterpaginate("pageClick");

      })

      $('.vbt-per-page-dropdown #dropdownMenuLink').on("change", (event) => {
        this.filterpaginate("perPageChange");
      })
      $('.pagination input[type=number]').on('keyup', (event) => {
        this.filterpaginate("pageChange");
      })
    }, 2000);
  }


  private getUserActivity() {
    this.$store.state.Loading = true;
    settingService.getUserActivity().then((res: any) => {
      if (res.data.status === true) {
        this.UserForm.start_date = res.data.data.start_date;
              this.UserForm.end_date = res.data.data.end_date;
              console.log(this.UserForm.start_date)
              console.log(this.UserForm.start_date)
        const UserActivity = res.data.data.user_activity;
        this.UserActivityData = UserActivity
        this.data_count = this.UserActivityData.length;
        this.filterpaginate("fresh")

      }
      this.$store.state.Loading = false;
    }, (err: any) => {
      this.$store.state.Loading = false;
      this.$store.dispatch('showErrorMsg', err.message);
    })
  }

  private createUserAcrivityTable() {
    const Doc = this;
    const Headers = [
      { label: 'ID', name: 'id', sort: true, visibility: true ,},
      { label: 'User ID', name: 'user_id', sort: true, visibility: true ,},
      { label: 'USER', name: 'username', sort: true, visibility: true},
      { label: 'HTTP METHOD', name: 'request_method', sort: true, visibility: true , },
      { label: 'URL', name: 'request_url', sort: true, visibility: true , row_text_alignment:  "text-left"},
      { label: 'RESPONSE CODE', name: 'response_code', sort: true, visibility: true},
      { label: 'DATETIME', name: 'datetime', sort: true, visibility: true , row_text_alignment:"text-left"},
      { label: 'USER IP', name: 'ip_address', sort: true, visibility: true},
    ];
    Doc.TableHeaders = Headers;
    Doc.TableConfig = config.tableconfig;
  }
  private FormatDate(date: any) {
    return  commonservice.FormatDateWithTime(date);
  }

  public FilterUserListData(){
    this.UserActivityData = []
    console.log(this.UserForm.start_date,'--------------startdate')
    console.log(this.UserForm.end_date,'--------------enddate')
    this.$store.state.Loading = true;
    settingService.getUserFilterActivity(this.UserForm) .then((res: any) => {
          this.$store.state.Loading = false;
          const UserActivity = res.data.data.user_activity;
          this.UserActivityData = UserActivity
          this.data_count = this.UserActivityData.length;
          this.filterpaginate("fresh")
      },
      (err: any) => {
        this.$store.state.Loading = false;
        this.$store.dispatch("showErrorMsg", err.message);
      });
  }

  onChangeQuery(event:Event){



    settingService.getUserActivityServerSidePagination(event).then((res)=> {
          console.log(res.data, "page responsse");
          if (res.data.status === true) {
            if (res.data.status === true) {
              const UserActivity = res.data.data.user_activity;
              this.UserActivityData = UserActivity
              this.data_count = this.UserActivityData.length;
              this.filterpaginate("fresh")

            }
          } else {
            this.$store.dispatch("showErrorMsg", res.data.message);
            this.$store.state.Loading = false;
          }
        }, (err)=> {1
          console.log(err, "pagination error ");

        })

    }
}
